import StatusInfoBox from "./StatusInfoBox";

export default StatusInfoBox;